import { requestWithoutToken, requestWithToken } from "../utils/apis";

export const fetchOrganizationList = async (page, limit, search = "") => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/organization/list?page=${page}&limit=${limit}&search=${search}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export const CreateNewOrganization = async (payload) => {
  try {
    const res = await requestWithoutToken(
      "POST",
      "/api/organization/signup",
      payload
    );
    return res;
  } catch (error) {
    return error?.response?.data;
  }
};
export const UpdateOrganization = async (id, payload) => {
    try {
        const response = await requestWithToken(
            "PUT",
            `/api/organization/${id}`,
            payload
        );

        return response.data;
    } catch (err) {
        return err?.response?.data || {
            status: 0,
            message: "Failed to update organization",
        };
    }
};
export const deleteOrganization = async (id) => {
    try {
        const response = await requestWithToken("DELETE", `/api/organization/${id}`);
        return response.data;
    } catch (err) {
        return err.response.data;
    }
};